module.exports = __webpack_public_path__ + "static/img/03.0611645.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/03.png
// module id = 6a3H
// module chunks = 2